/* eslint-disable */
import * as Yup from 'yup';
import { useState, useEffect, useRef } from 'react';
// material
import {
    Container, Card
} from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, Button, Box, InputAdornment, Tooltip, Grid, Autocomplete } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate, useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Divider from '@material-ui/core/Divider';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { AESEncryptionParam } from '../../../../helpers/AesEncrypt';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import SearchNotFound from '../../../SearchNotFound';
import Service from '../Service';
import Chip from '@material-ui/core/Chip';
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes, { func } from 'prop-types'
import { useTheme } from '@mui/material/styles'
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import { AlertDialog } from './../../Common/AlertDialog';
import { makeStyles } from '@material-ui/styles';
import { alpha, useTheme as useMuiTheme } from '@material-ui/core/styles';

let savedSearchState = null;

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

export default function StockAdjustmentListing(props) {
    const screenCode = 'STOCKADJUSTMENT';
    let encrypted = "";
    const navigate = useNavigate();
    const location = useLocation();
    const [date, setDate] = useState(new Date());
    const todayDate = (() => {
        const d = new Date();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${d.getFullYear()}-${month}-${day}`;
    })();
    const [formData, setFormData] = useState({
        groupID: "0",
        operationEntityTypeID: "1",
        factoryID: "0",
        productCategoryID: "0",
        productID: "0",
        fromDate: todayDate,
        toDate: todayDate
    });
    const [groupList, setGroupList] = useState([]);
    const [operationEntityTypeList, setOperationEntityTypeList] = useState([]);
    const [factoryList, setFactoryList] = useState([]);
    const [productCategoryList, setProductCategoryList] = useState([]);
    const [productList, setProductList] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [removeDetails, setRemoveDetails] = useState();
    const [message, setMessage] = useState("Remove Confirmation");
    const [EnableConfirmMessage, setEnableConfirmMessage] = useState(false);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false,
        isAddEditEnabled: false
    });

    const productAutocompleteFilter = (options, state) => {
    const input = (state.inputValue || '').trim().toLowerCase();
    if (input === '') {
        return options;
    }
    return options
        .filter((option) => (option.productName || '').toLowerCase().includes(input))
        .sort((a, b) => {
            const aName = (a.productName || '').toLowerCase();
            const bName = (b.productName || '').toLowerCase();
            const aExact = aName === input ? 0 : 1;
            const bExact = bName === input ? 0 : 1;
            return aExact - bExact;
        });
    };

    const [productCategoryWarning, setProductCategoryWarning] = useState(false);
    const [productOpen, setProductOpen] = useState(false);

    const stockAdjustmentListingSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
        operationEntityTypeID: Yup.number().min(1, 'Please Select Operation Entity Type').required('Operation Entity Type Required'),
        fromDate: Yup.string().required('From Date Required'),
        toDate: Yup.string().required('To Date Required').test('to-after-from', 'To Date must be on or after From Date', function (value) {
            var fromDate = this.parent.fromDate;
            if (!value || !fromDate) {
                return true;
            }
            return value >= fromDate;
        })
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityTypeID: formData.operationEntityTypeID,
            factoryID: formData.factoryID,
            productCategoryID: formData.productCategoryID,
            productID: formData.productID,
            fromDate: formData.fromDate,
            toDate: formData.toDate
        },
        validationSchema: stockAdjustmentListingSchema,
        onSubmit: (values) => {
            trackPromise(GetStockAdjustmentDetails(values))
        }
    });

    const useStyles = makeStyles((theme) => ({
        entryTypePillIn: {
            position: 'relative',
            overflow: 'hidden',
            display: 'inline-block',
            padding: '4px 14px',
            borderRadius: 999,
            minWidth: 60,
            textAlign: 'center',
            fontWeight: 600,
            borderWidth: 1,
            borderStyle: 'solid',
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            boxShadow: theme.shadows[1],
            backgroundColor: alpha(theme.palette.success.main, 0.25),
            borderColor: alpha(theme.palette.success.main, 0.35),
            color: theme.palette.text.primary,
        },
        entryTypePillOut: {
            position: 'relative',
            overflow: 'hidden',
            display: 'inline-block',
            padding: '4px 14px',
            borderRadius: 999,
            minWidth: 60,
            textAlign: 'center',
            fontWeight: 600,
            borderWidth: 1,
            borderStyle: 'solid',
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            boxShadow: theme.shadows[1],
            backgroundColor: alpha(theme.palette.error.main, 0.25),
            borderColor: alpha(theme.palette.error.main, 0.35),
            color: theme.palette.text.primary,
        },
    }));

    const classes = useStyles();
    const muiTheme = useMuiTheme();

    const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const initialFactoryLoadRef = useRef(true);
    const restoringRef = useRef(false);

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tableData.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    useEffect(() => {
        getPermissions();
        var successMessage = sessionStorage.getItem('stockAdjustmentSuccessMessage');
        if (successMessage) {
            toast.success(successMessage);
            sessionStorage.removeItem('stockAdjustmentSuccessMessage');
        }
    }, []);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWSTOCKADJUSTMENT');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find((p) => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find((p) => p.permissionCode == 'FACTORYDROPDOWN');
        var isAddEditEnabled = permissions.find((p) => p.permissionCode == 'ADDEDITSTOCKADJUSTMENT');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
            isAddEditEnabled: isAddEditEnabled !== undefined
        });

        if (!(location.state && location.state.fromAddEdit === true)) {
            savedSearchState = null;
        }

        if (savedSearchState) {
            restoringRef.current = true;
            setValues({ ...savedSearchState.values });
            trackPromise(GetStockAdjustmentDetails(savedSearchState.values));
        } else {
            setValues({
                ...values,
                groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
                operationEntityTypeID: parseInt(TokenDecoder.getFactoryTypeFromToken()),
                factoryID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
            });
        }
        trackPromise(GetAllGroups());
        trackPromise(GetAllOperationEntityTypes());
        trackPromise(GetProductCategoties());
    }

    async function GetProductCategoties() {
        var res = await Service.GetProductCategoties();
        if (res != null) {
            setProductCategoryList(res);
        }
    }

    async function GetAllOperationEntityTypes() {
        var res = await Service.GetAllOperationEntityTypes();
        if (res != null) {
            setOperationEntityTypeList(res);
        }
    }

    useEffect(() => {
        setFactoryList([]);
        if (initialFactoryLoadRef.current) {
            if (formik.values.groupID > 0 && formik.values.operationEntityTypeID > 0) {
                initialFactoryLoadRef.current = false;
                trackPromise(GetAllFactories());
            }
            return;
        }
        if (formik.values.factoryID > 0) {
            formik.setFieldValue('factoryID', "0");
        }
        if (formik.values.groupID > 0 && formik.values.operationEntityTypeID > 0) {
            trackPromise(GetAllFactories());
        }
    }, [formik.values.groupID, formik.values.operationEntityTypeID]);

    useEffect(() => {
        if (restoringRef.current) {
            return;
        }
        setTableData([]);
    }, [formik.values.factoryID]);

    useEffect(() => {
        setProductCategoryWarning(false);
        setProductList([]);
        if (restoringRef.current) {
            if (formik.values.productCategoryID > 0) {
                trackPromise(GetProductDetails());
            }
            return;
        }
        setTableData([]);
        if (formik.values.productID > 0) {
            formik.setFieldValue('productID', "0");
        }
        if (formik.values.productCategoryID > 0) {
            trackPromise(GetProductDetails());
        }
    }, [formik.values.productCategoryID]);

    useEffect(() => {
        if (restoringRef.current) {
            return;
        }
        setTableData([]);
    }, [formik.values.productID]);

    async function GetProductDetails() {
        var res = await Service.GetProductDetails(formik.values.factoryID, formik.values.productCategoryID);
        if (res != null) {
            setProductList(res);
        }
    }

    async function GetAllGroups() {
        var res = await Service.GetAllGroupsForDropDown();
        if (res != null) {
            setGroupList(res);
        }
    }

    async function GetAllFactories() {
        var res = await Service.GetAllFactoriesByFactoryType(formik.values.groupID, formik.values.operationEntityTypeID);
        if (res != null) {
            setFactoryList(res);
        }
    }

    async function clearAll() {
        savedSearchState = null;
        setValues({
            ...values,
            productCategoryID: "0",
            productID: "0",
            fromDate: todayDate,
            toDate: todayDate
        });
        setTableData([]);
    }

    function handleClick(data) {
        encrypted = AESEncryptionParam(data.stockAdjustmentID.toString());
        navigate('/dashboard/StockAdjustment/addedit/' + encrypted)
    }

    async function GetStockAdjustmentDetails(values) {
        setTableData([]);
        setPage(0);
        let model = {
            groupID: parseInt(values.groupID),
            operationEntityTypeID: parseInt(values.operationEntityTypeID),
            factoryID: parseInt(values.factoryID),
            productCategoryID: parseInt(values.productCategoryID),
            productID: parseInt(values.productID),
            fromDate: values.fromDate,
            toDate: values.toDate
        };
        var res = await Service.GetStockAdjustmentDetails(model);
        if (res != null) {
            setTableData(res);
        }
        savedSearchState = { values: { ...values }, tableData: res || [] };
        restoringRef.current = false;
    }

    function handleRemoveClick(data) {
        setRemoveDetails(data);
        setEnableConfirmMessage(true);
    }

    async function RemoveStockAdjustment(data) {
        var res = await Service.RemoveStockAdjustment(data.stockAdjustmentID, parseInt(TokenDecoder.getUserIDFromToken()));
        if (res.statusCode === "Success") {
            toast.success(res.message);
            trackPromise(GetStockAdjustmentDetails(formik.values));
        } else {
            toast.error(res.message);
        }
    }

    function confirmData(y) {
        if (y) {
            trackPromise(RemoveStockAdjustment(removeDetails));
        }
    }

    return (
        <>
            <LoadingComponent />
            <Page title="Stock Adjustment |  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/dashboard/StockAdjustment/addedit/" + AESEncryptionParam("0")}
                        btname="Add"
                        pageName="Stock Adjustment"
                        leftButtonHidden={!permissionList.isAddEditEnabled}
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <Stack spacing={4}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        disabled={!permissionList.isGroupFilterEnabled}
                                    >
                                        <MenuItem key={0} value={0}> Select Group</MenuItem>
                                        {groupList.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Operation Entity Type *"
                                        value={formik.values.operationEntityTypeID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('operationEntityTypeID')}
                                        error={Boolean(touched.operationEntityTypeID && errors.operationEntityTypeID)}
                                        helperText={touched.operationEntityTypeID && errors.operationEntityTypeID}
                                        disabled={!permissionList.isFactoryFilterEnabled}
                                    >
                                        <MenuItem key={0} value={0}> Select Operation Entity Type</MenuItem>
                                        {operationEntityTypeList.map((option) => (
                                            <MenuItem key={option.operationEntityTypeID} value={option.operationEntityTypeID}>
                                                {option.operationEntityTypeName}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Operation Entity"
                                        value={formik.values.factoryID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('factoryID')}
                                        error={Boolean(touched.factoryID && errors.factoryID)}
                                        helperText={touched.factoryID && errors.factoryID}
                                        disabled={!permissionList.isFactoryFilterEnabled}
                                    >
                                        <MenuItem key={0} value={0}> All Operation Entities</MenuItem>
                                        {factoryList.map((option) => (
                                            <MenuItem key={option.factoryID} value={option.factoryID}>
                                                {option.factoryName}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Product Category"
                                        value={formik.values.productCategoryID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('productCategoryID')}
                                        error={Boolean(touched.productCategoryID && errors.productCategoryID)}
                                        helperText={touched.productCategoryID && errors.productCategoryID}
                                    >
                                        <MenuItem key={0} value={0}> All Product Categories</MenuItem>
                                        {productCategoryList.map((option) => (
                                            <MenuItem key={option.productCategoryID} value={option.productCategoryID}>
                                                {option.productCategoryName}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Stack>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <Autocomplete
                                        id="productID"
                                        sx={{ width: { xs: '100%', sm: 'calc(25% - 12px)' } }}
                                        options={productList}
                                        filterOptions={productAutocompleteFilter}
                                        getOptionLabel={(option) => option.productName || ''}
                                        isOptionEqualToValue={(option, value) => option.productID === value.productID}
                                        value={productList.find((x) => x.productID == formik.values.productID) || null}
                                        onChange={(e, value) => formik.setFieldValue('productID', value === null ? '0' : value.productID)}
                                        open={productOpen}
                                        onOpen={() => {
                                            if (!(formik.values.productCategoryID > 0)) {
                                                setProductCategoryWarning(true);
                                                return;
                                            }
                                            setProductCategoryWarning(false);
                                            setProductOpen(true);
                                        }}
                                        onClose={() => setProductOpen(false)}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                name="productID"
                                                label="Product"
                                                size="small"
                                                fullWidth
                                                error={Boolean(productCategoryWarning || (touched.productID && errors.productID))}
                                                helperText={
                                                    productCategoryWarning
                                                        ? 'Please select a Category first'
                                                        : (touched.productID && errors.productID)
                                                }
                                            />
                                        )}    
                                    />
                                    <TextField
                                        size="small"
                                        label="From Date *"
                                        type="date"
                                        sx={{ width: { xs: '100%', sm: 'calc(25% - 12px)' } }}
                                        InputLabelProps={{ shrink: true }}
                                        value={formik.values.fromDate}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('fromDate')}
                                        error={Boolean(touched.fromDate && errors.fromDate)}
                                        helperText={touched.fromDate && errors.fromDate}
                                        inputProps={{ max: todayDate }}
                                    />
                                    <TextField
                                        size="small"
                                        label="To Date *"
                                        type="date"
                                        sx={{ width: { xs: '100%', sm: 'calc(25% - 12px)' } }}
                                        InputLabelProps={{ shrink: true }}
                                        value={formik.values.toDate}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('toDate')}
                                        error={Boolean(touched.toDate && errors.toDate)}
                                        helperText={touched.toDate && errors.toDate}
                                        inputProps={{ min: formik.values.fromDate, max: todayDate }}
                                    />
                                </Stack>
                                <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="flex-end" spacing={2}>
                                    <Button
                                        type="button"
                                        color='error'
                                        variant="outlined"
                                        onClick={() => clearAll()}
                                    > Clear</Button>
                                    <Button
                                        type="submit"
                                        color='secondary'
                                        variant="outlined"
                                    >Search</Button>
                                </Stack>
                            </Stack>
                        </Form>
                    </FormikProvider>
                    <br />
                    {tableData.length == 0 ?
                        <SearchNotFound searchQuery="Stock Adjustment" />
                        :
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                            <Card style={{ justifycontent: 'center', width: '85rem' }} >
                                <TableContainer component={Paper} >
                                    <Table size='small' aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="left">Adjustment Date</TableCell>
                                                <TableCell align="left">Product Category</TableCell>
                                                <TableCell align="left">Product Code</TableCell>
                                                <TableCell align="left">Product Name</TableCell>
                                                <TableCell align="left">Entry Type</TableCell>
                                                <TableCell align="right">Quantity</TableCell>
                                                {permissionList.isAddEditEnabled ?
                                                    <TableCell align="center">Actions</TableCell>
                                                    : null}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {(rowsPerPage > 0
                                                ? tableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                : tableData
                                            ).map((row) => (
                                                <TableRow key={row.stockAdjustmentID}>
                                                    <TableCell align="left">
                                                        {row.adjustmentDate == null ? '' : new Date(row.adjustmentDate).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' })}
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {row.productCategoryName}
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {row.productCode}
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {row.productName}
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        <Box
                                                            component="span"
                                                            className={row.entryType == 'IN' ? classes.entryTypePillIn : classes.entryTypePillOut}
                                                        >
                                                            {row.entryType == 'IN' ? 'IN' : 'OUT'}
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        {row.quantity == null ? '' : Number(row.quantity).toFixed(2)}
                                                    </TableCell>
                                                    {permissionList.isAddEditEnabled ?
                                                        <TableCell align="center">
                                                            <Tooltip title="Edit Stock Adjustment">
                                                                <IconButton aria-label="edit" onClick={() => handleClick(row)}>
                                                                    <EditIcon />
                                                                </IconButton>
                                                            </Tooltip>
                                                            <Tooltip title="Remove Stock Adjustment">
                                                                <IconButton aria-label="remove" onClick={() => handleRemoveClick(row)}>
                                                                    <DeleteIcon />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </TableCell>
                                                        : null}
                                                </TableRow>
                                            ))}
                                            {emptyRows > 0 && (
                                                <TableRow style={{ height: 53 * emptyRows }}>
                                                    <TableCell colSpan={permissionList.isAddEditEnabled ? 7 : 6} />
                                                </TableRow>
                                            )}
                                        </TableBody>
                                        <TableFooter>
                                            <TableRow>
                                                <TablePagination
                                                    rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                                    colSpan={permissionList.isAddEditEnabled ? 7 : 6}
                                                    count={tableData.length}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    SelectProps={{
                                                        inputProps: {
                                                            'aria-label': 'rows per page',
                                                        },
                                                        native: true,
                                                    }}
                                                    onPageChange={handleChangePage}
                                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                                    ActionsComponent={TablePaginationActions}
                                                />
                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </TableContainer>
                            </Card>
                        </Stack>
                    }
                </Container>
                <div hidden={true}>
                    <Grid item>
                        <AlertDialog confirmData={confirmData} headerMessage={message} viewPopup={EnableConfirmMessage}
                            discription={"Are you sure you want to remove this Stock Adjustment ?"} setViewPopup={setEnableConfirmMessage} />
                    </Grid>
                </div>
            </Page>
        </>
    );
}
